import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";

interface HeaderDownloadButtonProps {
  href: string;
}

export const HeaderDownloadButton = ({ href }: HeaderDownloadButtonProps) => (
  <TippyV2 content={t("help_widget.tooltip.download_transcript")}>
    <a
      href={href}
      download
      target="_blank"
      rel="noopener noreferrer"
      className="hover:bg-secondary text-light flex size-6 items-center rounded-full p-1"
    >
      <Icon type="16-download" size={16} />
    </a>
  </TippyV2>
);
